export const getUETTagViewerStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.tag-viewer': {
    zIndex: 250,
    '& .modal-dialog': {
      width: 900,
      'min-width': 750,
      'max-width': 'none',
      '& .modal-header': {
        display: 'block',

        '& .dialog-close-button': {
          fontFamily: iconFontFamily,
          fontSize: '16px',
          content: '"\\E711"',
          float: 'right',
          display: 'inline-block',
        },
        '& .dialog-close-button:before': {
          content: '"\\E711"',
        },
      },
      '& .modal-body': {
        '& a': {
          textDecoration: 'underline',
        },
        '& .form-group': {
          'margin-top': 2,
          'margin-bottom': 15,
          '& .form-control-static': {
            padding: 0,
            'min-height': 0,
          },
          '& .tab-content .form-control.active.tab-pane': {
            height: 130,
            'border-color': palette.neutralTertiary,
          },
          '& textarea': {
            resize: 'none',
          },
        },
        '& .row': {
          'font-size': 13,
          '& h6.type-bold': {
            'font-weight': 'bold',
          },
          '& h6.colon:after': {
            content: '": "',
          },
          '& h6': {
            'padding-right': [0, '!important'],
          },
          '& h6.tag-name': {
            overflow: 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap',
          },
        },
        '& ul.btn-group': {
          'list-style': 'none',
          'padding-left': 0,
          'margin-bottom': 0,
          '& .active>a': {
            'font-weight': 'bold',
            'background-color': '#E7F0F6',
          },
        },
      },
      '& .modal-footer': {
        '& .btn': {
          'min-width': 60,
          width: 'fit-content',
        },
        '& .pull-right': {
          float: ['left', '!important'],
          '& .row': {
            'margin-left': 0,
            'margin-right': 0,
          },
        },
      },
      '& .btn': {
        'line-height': 2.0,
      },
    },
  },
});
